export default __webpack_public_path__ + "static/media/logo-full-white - Copy.b439ff92.png";